import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ApiObject } from '../../services/api-calls.service';
import { ArticlesService } from '../../services/articles.service';
import { ModalService } from '../../shared/modal/modal.service';
import { EditingService } from '../../services/editing.service';
import { BlogpostComponent } from '../../shared/forms/blogpost/blogpost.component';
import { BlogListItemComponent } from '../blog-list-item/blog-list-item.component';

@Component({
  selector: 'app-blog-feed',
  templateUrl: './blog-feed.component.html',
  styleUrls: ['./blog-feed.component.scss'],
  imports: [BlogListItemComponent]
})
export class BlogFeedComponent {
  private articleService = inject(ArticlesService);
  private modal = inject(ModalService);
  private editService = inject(EditingService);
  private destroyRef = inject(DestroyRef);

  readonly editMode = this.editService.editMode;
  readonly type = 'blog';
  articles: ApiObject[] = [];

  constructor() {
    this.getArticles();
  }

  onAddItem() {
    this.modal.open(BlogpostComponent, {data: {type: this.type, title: 'Create blog post'}})
      .afterClosed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
        this.articleService.saveArticles(response);
        this.getArticles();
      });
  }

  onDeleted(id: string) {
    this.articles = this.articles.filter(article => article.id !== id);
  }

  getArticles() {
    this.articleService.getArticles(this.type).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
      this.articles = data.reverse();
    });
  }
}
